module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"topUp":"Top up","noOperations":"You have no operations yet","noOperationsFound":"No matching operations found"},"ru":{"topUp":"Пополнить","noOperations":"У вас пока нет операций","noOperationsFound":"Операции, соответствующие вашему запросу, не найдены"}}')
  delete Component.options._Ctor
}
